/* updated 7/24/17 by ML
 Last updated 5/5/16 by ML */

window.lfJS = {
	'widget': null,
    'jsCB': function(callback) {
        var lfCookieName = 'livefyre_token';
        deleteCookie(lfCookieName);

        var customStrings = {
            postButton: "Submit"
        };
        var commentConfig = eval(lfConfig.collectionMetaString);
        commentConfig[0].postToButtons = ['tw', 'fb', 'li'];
        commentConfig[0].disableAvatars = 'true';

        var networkConfig = {
            network: lfConfig.networkName,
            strings: customStrings
        };
		
		var fyreAuthObj = {};
        if (loginStatus && typeof(lfConfig.SSOtoken) != 'undefined') {
			var cval = lfConfig.SSOtoken[0];
            setCookie(lfCookieName, cval, 2);
			fyreAuthObj['livefyre'] = cval;
        }

        Livefyre.require(['fyre.conv#3', 'auth'], function(Conv, auth) {
            window.lfJS.conv = new Conv(networkConfig, commentConfig, function(widget) {
                window.lfJS.widget = widget;
                widget.on('initialRenderComplete', function(data) {
                    callback();
                });
                //Callback trigger for comment count update
                widget.on('commentCountUpdated', function(data) {
                    setTimeout('addSpecialty();$(".commentCountLink a").text($(".fyre-comment-count span").last().text());pluralComments();', 10);
                });
                // Its a callback triggered whenever a comment is posted
                widget.on('commentPosted', function(data) {
                    flagArticle(lfConfig.articleId);
                    showComments();
                    wmdPageLink('ar-comm-post');
                });
            });
            var d = {
                login: function(cb) {
                    cb(null, fyreAuthObj);
                },
                logout: function(cb) {
                    cb(null);
                    deleteCookie(lfCookieName);
                },
                viewProfile: function(author) {
                    //console.log(author);
                },
                editProfile: function(author) {
                    //console.log(author);
                }
            };
            auth.delegate(d);
            auth.authenticate(fyreAuthObj);
        });
    },
    'init': function(callback) {
        if (typeof lfConfig != 'undefined' && lfConfig != null && lfConfig.toString().trim() != '' && typeof lfConfig.collectionMetaString != 'undefined' && lfConfig.collectionMetaString != null && lfConfig.collectionMetaString.toString().trim() != '') {
            $.getScript('//cdn.livefyre.com/Livefyre.js', function() {
                lfJS.jsCB(callback);
            });
        }
    }
}

/* Avatar Population Functions */
function popHeadshot() {
    $('#newsBlogContainer .fyre-comment-user').each(function() {
        if (typeof blogAvatar[this.getAttribute('data-from')] != 'undefined') {
            $(this).find('.fyre-user-avatar').attr('src', blogAvatar[this.getAttribute('data-from')]);
        }
    });
    setTimeout(function() { $('.fyre-user-avatar').show(); }, 150);
}

/* Function to Detect DOM changes (because no callback after LiveFyre Sorting) */
var observeDOM = (function() {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
        eventListenerSupported = window.addEventListener;

    return function(obj, callback) {
        if (MutationObserver) {
            // define a new observer
            var obs = new MutationObserver(function(mutations, observer) {
                if (mutations[0].addedNodes.length || mutations[0].removedNodes.length)
                    callback();
            });
            // have the observer observe foo for changes in children
            obs.observe(obj, { childList: true, subtree: true });
        } else if (eventListenerSupported) {
            obj.addEventListener('DOMNodeInserted', callback, false);
            obj.addEventListener('DOMNodeRemoved', callback, false);
        }
    }
})();

var chgDetectFlg = false;
var chgDetectDeb;

function chgDetectCallback() {
    if (chgDetectFlg && $('#newsBlogContainer .fyre-comment-user').length > 0) {
        chgDetectFlg = false;
        popHeadshot();
        $('#newsBlogContainer .fyre-comment-media-link').parent().addClass('has-video'); //	Add extra classes for embedded videos
        $('.has-video').on('click', function() {
            $(this).addClass('active-video');
        });
    }
}

function initLvBlgContain(id) {
    observeDOM(document.getElementById(id), function() {
        if (chgDetectFlg) {
            $('.fyre-user-avatar').hide();
            clearTimeout(chgDetectDeb);
            chgDetectDeb = setTimeout(chgDetectCallback, 100);
        }
    });
}
/* Avatar Population Functions */
